// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"9e61e453","910":"ba5633e5"}[chunkId] + ".chunk.js";
};